export default "__VITE_ASSET__BW_49NyH__"